'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Loader = require('./Loader');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Loader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Loader/index.js
// module id = 64
// module chunks = 0 1